var Marionette = require('backbone.marionette');

var RemoteSuggesterView = require('../common/remote-suggester-input.js');

var CommonUtils = require('../../utils/common-utils.js');
var Constants = require('../../utils/constants');

var Radio = require('backbone.radio');
var services = Radio.channel('services');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');
var domtoimage = require('dom-to-image-more');

var FaceToFaceFormView = Marionette.View.extend({
        template: require('../../templates/med-forms/face-to-face-form.html'),

        regions: {
            languageSelect: '#language-select',
            stateSelect: '#state-select',
            reviewerSelect: '#reviewer-select',
            reqOrgSelect: '#req-org-select'
        },

        ui: {
            hospitalInformation: '#hospital-information',
            patientDemographics: '#patient-demographics',
            emergencyContact: '#emergency-contact',
            insuranceInformation: '#insurance-information',
            medicalInformationContent: '#medical-information-content',
            admissionDate: '#admission-date',
            dischargeDate: '#discharge-date',
            hospitalInput: '.hospital-input',
            hospitalEmail: '#hospital-email',
            hospitalPhone: '#hospital-phone',
            dob: '#dob',
            ssn: '#ssn',
            suffix: '#suffix',
            sex: '#sex',
            martialStatus: "#martial-status",
            address: '#address',
            city: "#city",
            zip: '#zip',
            personPhone: '#person-phone',
            personEmail: '#person-email',
            primaryContactName: '#primary-contact-name',
            primaryContactRelationship: '#primary-contact-rel',
            primaryContactPhone: '#primary-contact-phone',

            diagnosisSearchText: '#search-text',
            diagnosisSearchButton: '#search-button',
            diagnosisTable: '#diagnosis',
            selectedDiagnosisTable: '#selected-diagnosis',
            surgeriesTable: '#surgeries',
            addSurgery: '#add-surgery',

            diet: '#diet',
            allergies: '#allergies',
            briefMedicalHistory: '#brief-medical-history',
            complications: '#complications',
            clinicalIndication: '#clinical-indication',
            orders: '#orders',
            suggestedFrequency: '#suggested-frequency',
            ffDataInput: ".ff-data",
            phoneNumber: '#phone-number',

            languageSelectContent: '#language-select',
            selectedLanguages: '#selected-languages',

            primaryCarePhysicianInput: '.primary-care-physician-input',
            dateOfNextVisit: '#date-of-next-visit',

            referralChb: '.referral-chb',
            reasonChb: '.reason-chb',

            faceToFaceDate: '#ff-date',

            create: '#create',
            update: '#update',
            sign: '#sign',
            back: '#back'
        },

        events: {
            'click @ui.create': 'onCreate',
            'click @ui.update': 'onUpdate',
            'click @ui.sign': 'onSign',
            'click @ui.back': 'onBackToList',
            'change @ui.hospitalInput': 'onChangeHospitalInput',
            'change @ui.hospitalPhone': 'onHospitalPhoneChanged',
            'change @ui.hospitalEmail': 'onHospitalEmailChanged',
            'change .simple-input': 'onChangeSimpleInput',
            'change @ui.address': 'onChangeAddress',
            'change @ui.city': 'onChangeAddress',
            'change @ui.zip': 'onChangeAddress',
            'change @ui.personPhone': 'onPersonPhoneChanged',
            'change @ui.personEmail': 'onPersonEmailChanged',
            'change @ui.ssn': 'onSsnChange',
            'change .primary-contact': 'onChangePrimaryContact',
            'change @ui.primaryContactPhone': 'onPrimaryContactPhoneChanged',

            'keyup @ui.diagnosisSearchText': 'searchDiagnosis',
            'click @ui.diagnosisSearchButton': 'searchDiagnosis',
            'click .remove-diagnosis': 'onRemoveDiagnosis',
            'change @ui.diet': 'onChangeDiet',
            'change @ui.allergies': 'onChangeAllergies',
            'change @ui.briefMedicalHistory': 'onChangeBriefMedicalHistory',
            'change @ui.complications': 'onChangeComplications',
            'change @ui.ffDataInput': 'onChangeFfDataInput',
            'change @ui.phoneNumber': 'onPhoneNumberChanged',

            'click .language-primary': 'setLanguageAsPrimary',
            'click .remove-language': 'removeLanguage',

            'click @ui.addSurgery': 'addSurgery',
            'click .remove-surgery': 'onRemoveSurgery',

            'change @ui.primaryCarePhysicianInput': "onChangePrimaryCarePhysicianInput",

            'change @ui.referralChb': 'onReferralTypeCheck',
            'change @ui.reasonChb': 'onReasonCheck'
        },

        childViewEvents: {
            'suggestor:selected:language': 'onSelectLanguage',
            'suggestor:selected:state': 'onSelectState',
            'suggestor:selected:reviewer': 'onReviewerSelected',
            'suggestor:selected:req-org': 'onReqOrgSelected'
        },

        primaryLanguageColor: '#337ab7',
        secondaryLanguageColor: '#afc7dc',

        initialize: function (options) {
            var that = this;
            that.utils = new CommonUtils();
            if (options.model)
                this.data = options.model;
            else
                this.data = null;

            this.mode = that.data ? "edit" : "add";
            this.currentUser = options.currentUser;

            this.medProfile = options.medProfile;

            that.initReferralFormData();
            that.servicesAddresses = services.request('get:services:address');

            window.setTimeout(function () {
                if (_.isUndefined(that.servicesAddresses))
                    that.servicesAddresses = services.request('get:services:address');
            }, 1000);
        },

        templateContext: function () {
            var that = this;
            var hospitalEmail = that.ffForm && that.ffForm.data && that.ffForm.data.hospital && that.ffForm.data.hospital.hospitalContacts
                ? _.find(that.ffForm.data.hospital.hospitalContacts, function (contact) {
                    return contact.type == 'EMAIL';
                }) : "";
            var hospitalPhone = that.ffForm && that.ffForm.data && that.ffForm.data.hospital && that.ffForm.data.hospital.hospitalContacts
                ? _.find(that.ffForm.data.hospital.hospitalContacts, function (contact) {
                    return contact.type == 'PHONE';
                }) : "";
            var patientEmail = that.ffForm && this.ffForm.person && this.ffForm.person.contacts
                ? _.find(this.ffForm.person.contacts, function (contact) {
                    return contact.type == 'EMAIL';
                }) : "";
            var patientPhone = that.ffForm && this.ffForm.person && this.ffForm.person.contacts
                ? _.find(this.ffForm.person.contacts, function (contact) {
                    return contact.type == 'PHONE';
                }) : "";
            var primaryContactPhone = that.ffForm && this.ffForm.person && this.ffForm.person.primaryContacts && this.ffForm.person.primaryContacts[0].contacts
                ? _.find(this.ffForm.person.primaryContacts[0].contacts, function (contact) {
                    return contact.type == 'PHONE';
                }) : "";
            return {
                martialStatuses: that.utils.martialStatuses(),
                hospitalName: "Grady Memorial Hospital",
                mode: that.mode,
                userCanUpdate: that.data && (that.data.createdBy.id == that.currentUser || that.data.reviewer.id == that.currentUser),
                userCanSign: that.data && that.data.reviewer.id == that.currentUser,

                ffForm: that.ffForm,
                patientAddress: that.patientAddress,
                hospitalEmail: hospitalEmail ? hospitalEmail.data : "",
                hospitalPhone: hospitalPhone ? hospitalPhone.data : "",
                patientEmail: patientEmail ? patientEmail.data : "",
                patientPhone: patientPhone ? patientPhone.data : "",
                primaryContacts: this.ffForm && this.ffForm.person && this.ffForm.person.primaryContacts
                    ? this.ffForm.person.primaryContacts[0] : {},
                primaryContactPhone: primaryContactPhone ? primaryContactPhone.data : "",
                primaryPhysician: this.ffForm && this.ffForm.person ? this.ffForm.person.primaryPhysician : {},
                referralTypes: this.ffForm && this.ffForm.data ? this.ffForm.data.referralTypes : [],
                reasons: this.ffForm && this.ffForm.data ? this.ffForm.data.reasons : []
            }
        },

        initReferralFormData: function () {

            var that = this;

            if (!this.data) {
                this.ffForm = {
                    person: {
                        addresses: [{
                            uuid: this.utils.generatedUUID(),
                            country: "US",
                            state: "",
                            county: "",
                            zip: "",
                            town: "",
                            address: "",
                            usage: "WP"
                        }],
                        languages: [],
                        contacts: [],
                        primaryContacts: [
                            {
                                contacts: []
                            }
                        ],
                        primaryPhysician: {
                            name: "",
                            relationship: "",
                            dateOfNextVisit: 0,
                            locationOfNextVisit: ""
                        }
                    },
                    medProfile: {
                        diseases: [],
                        surgeries: [],
                        diet: "",
                        allergy: "",
                        briefMedicalHistory: "",
                        complication: ""
                    },
                    data: {
                        hospital: {
                            name: "Grady Memorial Hospital",
                            hospitalContacts: []
                        },
                        referralTypes: [],
                        reasons: []
                    },
                    reviewer: null,
                    requestingOrg: null
                }

                this.patientAddress = this.ffForm.person.addresses[0];

            } else {

                this.ffForm = {
                    person: _.omit(this.data.patient.object, "@class"),
                    medProfile: that.medProfile,
                    data: this.data.data,
                    reviewer: this.data.reviewer ? this.data.reviewer.id : null
                }

                this.patientAddress = this.ffForm.person.addresses[0];
            }
        },

        onRender: function () {
            window.document.title = "Face to face form";
            var that = this;

            var now = new Date();

            that.ui.hospitalInformation.collapse("show");
            that.ui.patientDemographics.collapse("show");
            that.ui.emergencyContact.collapse("show");
            that.ui.insuranceInformation.collapse("show");
            that.ui.medicalInformationContent.collapse("show");

            that.ui.admissionDate.datepicker({
                format: 'mm/dd/yyyy',
                clearBtn: true
            }).on('changeDate', function (e) {
                $(this).datepicker('hide');
                that.ffForm.data.hospital.admissionDate = that.utils.dateToLong(e.target.value);
            }).on('clearDate', function (e) {
                that.ffForm.data.hospital.admissionDate = 0;
            });
            if (that.mode == 'add') {
                that.ui.admissionDate.datepicker('update', now);
                that.ffForm.data.hospital.admissionDate = that.utils.dateToLong(now);
            } else {
                if (that.ffForm.data.hospital) {
                    that.ui.admissionDate.datepicker('update', that.utils.longToDateTimeFormatted(that.ffForm.data.hospital.admissionDate, 'MM/DD/YYYY'));
                }
            }

            that.ui.dischargeDate.datepicker({
                format: 'mm/dd/yyyy',
                clearBtn: true
            }).on('changeDate', function (e) {
                $(this).datepicker('hide');
                that.ffForm.data.hospital.dischargeDate = that.utils.dateToLong(e.target.value);
            }).on('clearDate', function (e) {
                that.ffForm.data.hospital.dischargeDate = 0;
            });

            if (that.mode == 'edit' && that.ffForm.data.hospital) {
                that.ui.dischargeDate.datepicker('update', that.utils.longToDateTimeFormatted(that.ffForm.data.hospital.dischargeDate, 'MM/DD/YYYY'));
            }

            that.ui.dob.datepicker({
                format: 'mm/dd/yyyy',
                clearBtn: true
            }).on('changeDate', function (e) {
                $(this).datepicker('hide');
                that.ffForm.person.birthData = that.utils.dateToLong(e.target.value);
            }).on('clearDate', function (e) {
                that.ffForm.person.birthData = 0;
            });

            if (that.mode == 'edit' && that.ffForm.person) {
                that.ui.dob.datepicker('update', that.utils.longToDateTimeFormatted(that.ffForm.person.birthData, 'MM/DD/YYYY'));
            }

            that.ui.dateOfNextVisit.datepicker({
                format: 'mm/dd/yyyy',
                clearBtn: true
            }).on('changeDate', function (e) {
                $(this).datepicker('hide');
                that.ffForm.person.primaryPhysician.dateOfNextVisit = that.utils.dateToLong(e.target.value);
            }).on('clearDate', function (e) {
                that.ffForm.person.primaryPhysician.dateOfNextVisit = 0;
            });

            if (that.mode == 'edit' && that.ffForm.person && that.ffForm.person.primaryPhysician) {
                that.ui.dateOfNextVisit.datepicker('update', that.utils.longToDateTimeFormatted(that.ffForm.person.primaryPhysician.dateOfNextVisit, 'MM/DD/YYYY'));
            }

            that.ui.faceToFaceDate.datepicker({
                format: 'mm/dd/yyyy',
                clearBtn: true
            }).on('changeDate', function (e) {
                $(this).datepicker('hide');
                that.ffForm.data.faceToFaceDate = that.utils.dateToLong(e.target.value);
            }).on('clearDate', function (e) {
                that.ffForm.data.faceToFaceDate = 0;
            });

            if (that.mode == 'edit' && that.ffForm.data && that.ffForm.data.faceToFaceDate) {
                that.ui.faceToFaceDate.datepicker('update', that.utils.longToDateTimeFormatted(that.ffForm.data.faceToFaceDate, 'MM/DD/YYYY'));
            }

            var sexSelectize = this.ui.sex.selectize({
                allowEmptyOption: false
            });

            var suffixSelectize = this.ui.suffix.selectize({
                allowEmptyOption: false
            });

            var martialStatusSelectize = this.ui.martialStatus.selectize({
                allowEmptyOption: false
            });

            that.ui.hospitalPhone.mask("(999) 999-9999", {
                autoclear: false,
                completed: function () {
                    that.clearError(this);
                    that.contactChange(that.ffForm.data.hospital, "hospitalContacts", this.val(), 'PHONE');
                }
            });
            that.ui.ssn.mask("999-99-9999", {
                autoclear: false,
                completed: function () {
                    that.clearError(this);
                    that.ffForm.person["ssn"] = this.val();
                }
            });
            that.ui.personPhone.mask("(999) 999-9999", {
                autoclear: false,
                completed: function () {
                    that.clearError(this);
                    that.onContactChanged("contacts", this.val(), 'PHONE');
                }
            });
            that.ui.primaryContactPhone.mask("(999) 999-9999", {
                autoclear: false,
                completed: function () {
                    that.clearError(this);
                    that.primaryContactPhoneChange(this.val());
                }
            });
            that.ui.phoneNumber.mask("(999) 999-9999", {
                autoclear: false,
                completed: function () {
                    that.clearError(this);
                    that.ffForm.data.phoneNumber = this.val();
                }
            });

            that.showlanguageSelect();
            that.showStateSelect();
            that.showReviewerSelect();
            that.showReqOrgSelect();

            that.initLanguages(that.ffForm.person.languages);
            that.initDiseases(that.ffForm.medProfile.diseases);
            that.initSurgeries(this.ffForm.medProfile.surgeries);

            that.disableSeparateFields();
        },

        disableSeparateFields: function () {
            var that = this;
            window.setTimeout(function () {
                //that.ui.countrySelect.find('#country').attr('disabled', true);
            }, 500);
        },

        onChangeHospitalInput: function (event) {
            var name = event.target.name;
            if (true) {

            }
            this.ffForm.data.hospital[name] = event.target.value;
        },

        onChangeSimpleInput: function (event) {
            this.ffForm.person[event.target.name] = event.target.value;
        },

        onChangePrimaryCarePhysicianInput: function (event) {
            this.ffForm.person.primaryPhysician[event.target.name] = event.target.value;
        },

        onHospitalPhoneChanged: function (event) {
            if (event.target.value.indexOf('_') > -1) {
                this.showError($(event.target), "Uncompleted");
                this.contactChange(this.ffForm.data.hospital, "hospitalContacts", '', 'PHONE');
            } else if (_.isEmpty(event.target.value)) {
                this.clearError($(event.target));
                this.contactChange(this.ffForm.data.hospital, "hospitalContacts", '', 'PHONE');
            }
        },

        onHospitalEmailChanged: function (event) {
            var val = event.target.value;
            if (this.utils.isValidEmail(val) || _.isEmpty(val)) {
                this.contactChange(this.ffForm.data.hospital, "hospitalContacts", val, 'EMAIL');
                this.clearError($(event.target));
            } else {
                this.contactChange(this.ffForm.data.hospital, "hospitalContacts", '', 'EMAIL');
                this.showError($(event.target), "Invalid e-mail");
            }
        },

        onPersonPhoneChanged: function (event) {

            if (event.target.value.indexOf('_') > -1) {
                this.showError($(event.target), "Uncompleted");
                this.onContactChanged("contacts", '', 'PHONE');
            } else if (_.isEmpty(event.target.value)) {
                this.clearError($(event.target));
                this.onContactChanged("contacts", '', 'PHONE');
            }
        },

        onSsnChange: function (event) {

            if (event.target.value.indexOf('_') > -1) {
                this.showError($(event.target), "Uncompleted");
                this.ffForm.person["ssn"] = "";
            } else if (_.isEmpty(event.target.value)) {
                this.clearError($(event.target));
                this.ffForm.person["ssn"] = "";
            }
        },

        onPersonEmailChanged: function (event) {
            var val = event.target.value;
            if (this.utils.isValidEmail(val) || _.isEmpty(val)) {
                this.onContactChanged("contacts", val, 'EMAIL');
                this.clearError($(event.target));
            } else {
                this.onContactChanged("contacts", '', 'EMAIL');
                this.showError($(event.target), "Invalid e-mail");
            }
        },

        onContactChanged: function (contactField, val, contactType) {
            if (_.isEmpty(val)) {
                this.ffForm.person[contactField] = this.ffForm.person[contactField].filter(function (contact) {
                    return contact.type != contactType;
                });
            } else {
                if (_.isUndefined(_.findWhere(this.ffForm.person[contactField], {type: contactType})))
                    this.ffForm.person[contactField].push({
                        data: val,
                        type: contactType
                    });
                else
                    this.ffForm.person[contactField].forEach(function (contact) {
                        if (contact.type == contactType)
                            contact.data = val;
                    });
            }
        },

        contactChange: function (target, contactField, val, contactType) {
            if (_.isEmpty(val)) {
                target[contactField] = target[contactField].filter(function (contact) {
                    return contact.type != contactType;
                });
            } else {
                if (_.isUndefined(_.findWhere(target[contactField], {type: contactType})))
                    target[contactField].push({
                        data: val,
                        type: contactType
                    });
                else
                    target[contactField].forEach(function (contact) {
                        if (contact.type == contactType)
                            contact.data = val;
                    });
            }
        },

        onChangeAddress: function () {
            this.rebuildAddress();
        },

        onSelectState: function (selected) {
            this.rebuildAddress();
        },

        onReviewerSelected: function (selectedId) {
            this.ffForm.reviewer = selectedId;
        },

        onReqOrgSelected: function (selectedId) {
            this.ffForm.requestingOrg = selectedId;
        },

        rebuildAddress: function () {
            var address = this.ui.address.val();
            var city = this.ui.city.val();
            var state = this.getChildView('stateSelect').getSelectedId();
            var zip = this.ui.zip.val();

            this.patientAddress.address = address;
            this.patientAddress.town = city;
            this.patientAddress.state = state;
            this.patientAddress.zip = zip;
        },

        onChangePrimaryContact: function (event) {
            this.ffForm.person.primaryContacts[0][event.target.name] = event.target.value;
        },

        onPrimaryContactPhoneChanged: function (event) {
            if (event.target.value.indexOf('_') > -1) {
                this.showError($(event.target), "Uncompleted");
                this.primaryContactPhoneChange('');
            } else if (_.isEmpty(event.target.value)) {
                this.clearError($(event.target));
                this.primaryContactPhoneChange('');
            }
        },

        onPhoneNumberChanged: function (event) {
            if (event.target.value.indexOf('_') > -1) {
                this.showError($(event.target), "Uncompleted");
                this.ffForm.data.phoneNumber = "";
            } else if (_.isEmpty(event.target.value)) {
                this.clearError($(event.target));
                this.ffForm.data.phoneNumber = "";
            }
        },

        primaryContactPhoneChange: function (val) {
            var contactType = 'PHONE';
            if (_.isEmpty(val)) {
                this.ffForm.person.primaryContacts[0].contacts = this.ffForm.person.primaryContacts[0].contacts.filter(function (contact) {
                    return contact.type != contactType;
                });
            } else {
                if (_.isUndefined(_.findWhere(this.ffForm.person.primaryContacts[0].contacts, {type: contactType})))
                    this.ffForm.person.primaryContacts[0].contacts.push({
                        data: val,
                        type: contactType
                    });
                else
                    this.ffForm.person.primaryContacts[0].contacts.forEach(function (contact) {
                        if (contact.type == contactType)
                            contact.data = val;
                    });
            }
        },

        validateReferralForm: function () {

            if (this.getErrorsCount() > 0)
                return "Some fields with errors";

            if (_.isEmpty(this.ffForm.person.firstName || _.isEmpty(this.ffForm.person.lastName)))
                return 'Please, fill first name and last name of Patient';

            if (_.isEmpty(this.ffForm.reviewer)) {
                return 'Please, select Reviewer';
            }

            return "";
        },

        getErrorsCount: function () {
            return this.$el.find('.has-error').length;
        },

        onCreate: function () {
            var that = this;

            var errorText = that.validateReferralForm();
            if (!_.isEmpty(errorText)) {
                notificationsChannel.request('show:notification', errorText);
                return;
            }

            console.log(that.ffForm);

            that.utils.showSpinner();
            $.ajax({
                type: "POST",
                url: '/api/face-to-face-form',
                data: JSON.stringify(that.ffForm),
                contentType: 'application/json',
                statusCode: {
                    200: function (response) {
                        that.utils.hideSpinner();
                        $.notify("Face-to-Face Form created successfully", "success");
                        Backbone.history.navigate('/ff-forms', {trigger: true});
                    }
                },
                error: function (e) {
                    that.utils.hideSpinner();
                    notificationsChannel.request('show:notification', JSON.parse(e.responseText));
                }
            });
        },

        onUpdate: function () {
            var that = this;

            var errorText = that.validateReferralForm();
            if (!_.isEmpty(errorText)) {
                notificationsChannel.request('show:notification', errorText);
                return;
            }

            console.log(that.ffForm);

            that.utils.showSpinner();
            $.ajax({
                type: "PUT",
                url: '/api/face-to-face-form/' + this.data.id,
                data: JSON.stringify(that.ffForm),
                contentType: 'application/json',
                statusCode: {
                    200: function (response) {
                        that.utils.hideSpinner();
                        $.notify("Face-to-Face Form updated successfully", "success");
                        Backbone.history.navigate('/ff-forms', {trigger: true});
                    }
                },
                error: function (e) {
                    that.utils.hideSpinner();
                    notificationsChannel.request('show:notification', JSON.parse(e.responseText));
                }
            });
        },

        onSign: function () {
            var that = this;
            that.utils.showSpinner();
            var element = document.getElementById("buttons");
            var removedChildButtons = [];
            while (element.firstChild) {
                removedChildButtons.push(element.removeChild(element.firstChild));
            }

            var restoreButtons = function () {
                removedChildButtons.forEach(function (buttonEl) {
                    element.appendChild(buttonEl);
                });
            }

            domtoimage.toPng(document.getElementById('face-to-face-form-container'), {bgcolor: '#FFFFFF', width: '1500'})
                .then(function (dataUrl) {
                    $.ajax({
                        type: "POST",
                        url: '/api/face-to-face-form/sign/' + that.data.id,
                        data: dataUrl.replace("data:image/png;base64,", ""),
                        contentType: 'text/plain',
                        statusCode: {
                            200: function (response) {
                                that.utils.hideSpinner();
                                $.notify("Face-to-Face Form signed successfully", "success");
                                Backbone.history.navigate('/ff-forms', {trigger: true});
                            }
                        },
                        error: function (e) {
                            that.utils.hideSpinner();
                            notificationsChannel.request('show:notification', JSON.parse(e.responseText));
                            restoreButtons();
                        }
                    });
                })
                .catch(function (error) {
                    console.error('oops, something went wrong!', error);
                    that.utils.hideSpinner();
                    restoreButtons();
                });
            /*
                        return;

                        domtoimage.toBlob(document.getElementById('face-to-face-form-container'), {bgcolor: '#FFFFFF', width: '1200'})
                            .then(function (blob) {
                                console.log(blob);

                                var a = document.createElement("a");
                                document.body.appendChild(a);
                                a.style = "display: none";
                                var url = window.URL.createObjectURL(blob);
                                a.href = url;
                                a.download = name;
                                a.click();
                                window.URL.revokeObjectURL(url);

                                var fileReader = new FileReader();
                                fileReader.onload = function (event) {
                                    var result = event.target.result;
                                    console.log(result);
                                    that.utils.showSpinner();

                                    $.ajax({
                                        type: "POST",
                                        url: '/api/face-to-face-form/sign/' + that.data.id,
                                        data: result,
                                        contentType: 'application/octet-stream',
                                        statusCode: {
                                            200: function (response) {
                                                that.utils.hideSpinner();
                                                $.notify("Face-to-Face Form signed successfully", "success");
                                                Backbone.history.navigate('/ff-forms', {trigger: true});
                                            }
                                        },
                                        error: function (e) {
                                            that.utils.hideSpinner();
                                            notificationsChannel.request('show:notification', JSON.parse(e.responseText));
                                        }
                                    });
                                };
                                fileReader.readAsArrayBuffer(blob);
                            });*/
        },

        onBackToList: function () {
            Backbone.history.navigate('/ff-forms', {trigger: true});
        },

        showlanguageSelect: function () {
            var that = this;

            that.showChildView('languageSelect', new RemoteSuggesterView({
                tag: 'language',
                inputId: 'language',
                maxNumberOfElements: 20,
                url: '/api/reference/languages/~~~',
                symbolForSearchInUrl: '~~~',
                listLocation: function (data) {
                    return data;
                },
                getIdFn: function (element) {
                    return element;
                },
                getValueFn: function (element) {
                    return element;
                },
                classes: ["form-control"],
                placeholder: "Language",
                findSelectedIdBySelectedIndex: function (arr, index) {
                    return arr[index] || null;
                }
            }));
        },

        showStateSelect: function () {
            var that = this;

            that.showChildView('stateSelect', new RemoteSuggesterView({
                tag: 'state',
                inputId: 'state',
                maxNumberOfElements: 20,
                url: '/api/reference/states/~~~',
                symbolForSearchInUrl: '~~~',
                listLocation: function (data) {
                    return data;
                },
                getValueFn: function (element) {
                    return element;
                },
                classes: ["form-control"],
                placeholder: "State",
                findSelectedIdBySelectedIndex: function (arr, index) {
                    return arr[index] || null;
                },
                defaultSelected: this.patientAddress.state
            }));
        },

        showReviewerSelect: function () {
            var that = this;
            that.reviewerSelectView = new RemoteSuggesterView({
                maxNumberOfElements: 100,
                url: '/api/person/preview?page-size=' + 100
                + '&sortby=name&like_name=~~~&object_isMd=true&object_mergeable=false',
                symbolForSearchInUrl: '~~~',
                listLocation: function (data) {
                    return data.filter(function (item) {
                        return item.object;
                    });
                },
                getValueFn: function (element) {
                    return element.name;
                },
                classes: ["form-control"],
                placeholder: "Begin to Type and Select Reviewer",
                findSelectedIdBySelectedIndex: function (arr, index) {
                    return (arr[index] || {}).id;
                },
                tag: 'reviewer',
                defaultSelected: this.data ? this.data.reviewer : null
            });

            that.showChildView('reviewerSelect', that.reviewerSelectView);
        },

        showReqOrgSelect: function () {
            var that = this;
            that.reqOrgSelectView = new RemoteSuggesterView({
                maxNumberOfElements: 100,
                url: '/api/dbo/preview?page-size=' + 100
                + '&sortby=name&like_name=~~~&type=organization',
                symbolForSearchInUrl: '~~~',
                listLocation: function (data) {
                    return data.filter(function (item) {
                        return item.object;
                    });
                },
                getValueFn: function (element) {
                    return element.name;
                },
                classes: ["form-control"],
                placeholder: "Begin to Type and Select Requesting Organization",
                findSelectedIdBySelectedIndex: function (arr, index) {
                    return (arr[index] || {}).id;
                },
                tag: 'req-org',
                defaultSelected: this.data ? this.data.requestingOrg : null
            });

            that.showChildView('reqOrgSelect', that.reqOrgSelectView);
        },

        initLanguages: function (languages) {
            var that = this;
            languages.forEach(function (lang) {
                that.addLang(lang);
            });
        },

        initDiseases: function (diseases) {
            var that = this;
            diseases.forEach(function (disease) {
                that.diseasesRender(disease);
            });
        },

        initSurgeries: function (surgeries) {
            var that = this;
            surgeries.forEach(function (surgery) {
                that.renderSurgery(surgery.id);
            });
        },

        onSelectLanguage: function (lang) {
            var that = this;
            if (!_.isNull(lang) && _.isUndefined(_.findWhere(that.ffForm.person.languages, {language: lang}))) {
                this.addLang({
                    language: lang,
                    primary: false
                });
                that.ffForm.person.languages.push({
                    language: lang,
                    primary: false
                });
            }
        },

        addLang: function (lang) {
            var that = this;
            var liContent = "<li class='list-group-item' id='" + that.langToId(lang.language) + "'>"
                + "<div class='row'>"
                + "<div class='col-xs-5 col-md-5'>"
                + lang.language + ""
                + "</div>"
                + "<div class='col-xs-5 col-md-5'>"
                + "Primary? <input type='checkbox' class='language-primary' title='Set as primary'" + (lang.primary ? " checked " : "")
                + " style='margin-left:10px;'/> "
                + "</div>"
                + "<div class='col-xs-1 col-md-1'>"
                + "<span class='glyphicon glyphicon-remove clickable remove-language' title='Remove' style='margin-left:10px;'/> "
                + "</div>"
                + "</div>"
                + "</li>";
            that.ui.selectedLanguages.append(liContent);
        },

        setLanguageAsPrimary: function (event) {
            var that = this;
            var currentLiEl = $(event.target).closest('li');
            var lang = that.idToLang(currentLiEl.attr('id'));
            if (event.target.checked == true) {
                currentLiEl.parent().find('li').each(function () {
                    var currentLi = $(this);
                    if (lang != that.idToLang(currentLi.attr('id'))) {
                        currentLi.find('.language-primary').prop('checked', false);
                    }
                });
            }

            that.ffForm.person.languages.forEach(function (language) {
                if (language.language == lang)
                    language.primary = event.target.checked;
                else
                    language.primary = false;
            });
        },

        removeLanguage: function (event) {
            var that = this;
            var li = $(event.target).closest('li');
            var lang = that.idToLang(li.attr('id'));
            that.ffForm.person.languages = that.ffForm.person.languages.filter(function (language) {
                return language.language != lang;
            });
            li.remove();
        },

        langToId: function (lang) {
            return lang.replace(' ', '_');
        },

        idToLang: function (lang) {
            return lang.replace('_', ' ');
        },

        searchDiagnosis: function (event) {
            var that = this;

            var searchText = that.ui.diagnosisSearchText.val();
            if (searchText.length <= 1) return;

            that.ui.diagnosisTable.find('tr:not(:first)').remove();

            //$('#search-results tr:not(:first)').remove();

            if (event.keyCode == 13 || event.target.id == that.ui.diagnosisSearchButton.attr('id')) {

                if (typeof that.servicesAddresses["icdServiceAddress"] != "undefined") {
                    that.ui.diagnosisSearchText.addClass('data-loader');
                    $.when(
                        $.ajax({
                            type: "GET",
                            url: that.servicesAddresses["icdServiceAddress"] +
                            '/search?terms=' + searchText
                        })
                    ).done(function (resp) {
                        that.resfreshDiagnosisTableFromICDResults(resp || []);
                        that.ui.diagnosisSearchText.removeClass('data-loader');
                    }).fail(function (jqXHR, textStatus) {
                        that.ui.diagnosisSearchText.removeClass('data-loader');
                        notificationsChannel.request('show:notification', "Error. ICD service is unavailable");
                    });
                }
            }
        },

        resfreshDiagnosisTableFromICDResults: function (results) {
            var that = this;
            var icdName = "ICD";

            results.forEach(function (item) {
                var newRowContent = "<tr class='clickable' id='" + item.code +
                    "'><td><button class='add-to-left' title='Add to selected'>Add to selected</button></td><td>" + icdName + "-"
                    + item.version + "</td><td>"
                    + item.code + "</td><td>" + item.name + "</td></tr>";
                that.ui.diagnosisTable.find('tbody').append(newRowContent);
            });

            that.ui.diagnosisTable.find('tr:not(:first)').on('dblclick', function (event) {
                var id = event.currentTarget.id;
                $(this).addClass('selected').siblings().removeClass('selected');
                that.onDiagnosisSelected(id, results, icdName);
            });
            that.ui.diagnosisTable.find('.add-to-left').on('click', function (event) {
                var id = $(event.currentTarget).parent().parent().attr('id');
                that.onDiagnosisSelected(id, results, icdName);
            });
        },

        onDiagnosisSelected: function (selectedId, results, type) {
            var that = this;
            var selected = _.findWhere(results, {code: selectedId});

            var alreadyExists = _.findWhere(this.ffForm.medProfile.diseases, {diseaseId: selectedId});
            if (!_.isUndefined(alreadyExists))
                return;

            this.ffForm.medProfile.diseases.push({
                typeOfId: type + '-' + selected.version,
                diseaseId: selected.code,
                name: selected.name
            });

            that.diseasesRender(selected);
        },

        diseasesRender: function (selected) {
            var that = this;

            var rowId = selected.code || selected.diseaseId;
            var dateOfOnsetElId = "date_" + (selected.code || selected.diseaseId);

            var newRowContent = "<tr class='clickable' id='" + rowId + "'><td>ICD-"
                + selected.version + "</td><td>"
                + (selected.code || selected.diseaseId) + "</td><td>"
                + selected.name + "</td><td><input class='form-control' type='text' id='" + dateOfOnsetElId
                + "'></td><td><span class='glyphicon glyphicon-remove clickable remove-diagnosis' title='Remove'/></td></tr>";
            this.ui.selectedDiagnosisTable.find('tbody').append(newRowContent);

            var added = _.findWhere(this.ffForm.medProfile.diseases, {diseaseId: selected.code || selected.diseaseId});

            $(function () {
                $('#' + dateOfOnsetElId).datepicker({
                    format: 'mm/dd/yyyy',
                    clearBtn: true
                }).on('changeDate', function (e) {
                    $(this).datepicker('hide');
                    added.dateOfOnset = that.utils.dateToLong(e.target.value);
                }).on('clearDate', function (e) {
                    added.dateOfOnset = 0;
                });

                if (that.mode == 'edit') {
                    $('#' + dateOfOnsetElId).datepicker('update', that.utils.longToDateTimeFormatted(added.dateOfOnset, 'MM/DD/YYYY'));
                }
            });
        },

        onRemoveDiagnosis: function (event) {
            var row = $(event.target);
            var diagnosisId = row.parent().parent().attr('id');
            this.ffForm.medProfile.diseases = this.ffForm.medProfile.diseases.filter(function (d) {
                return d.diseaseId != diagnosisId;
            });
            this.ui.selectedDiagnosisTable.find('tr[id="' + diagnosisId + '"]').remove();
        },

        addSurgery: function () {
            var that = this;

            var uniqueId = that.utils.generatedUUID();

            this.ffForm.medProfile.surgeries.push({
                id: uniqueId,
                type: "",
                date: 0
            });
            that.renderSurgery(uniqueId);
        },

        renderSurgery: function (uniqueId) {

            var that = this;

            var typeElId = "type_" + uniqueId;
            var dateElId = "date_" + uniqueId;

            var newRowContent = "<tr class='clickable' id='" + uniqueId
                + "'><td><input class='form-control' type='text' id='" + typeElId
                + "'></td><td><input class='form-control' type='text' id='" + dateElId
                + "'></td><td><span class='glyphicon glyphicon-remove clickable remove-surgery' title='Remove'/></td></tr>";
            this.ui.surgeriesTable.find('tbody').append(newRowContent);

            var added = _.findWhere(this.ffForm.medProfile.surgeries, {id: uniqueId});

            $(function () {

                $('#' + typeElId).on('change', function (e) {
                    added.type = e.target.value;
                });
                $('#' + dateElId).datepicker({
                    format: 'mm/dd/yyyy',
                    clearBtn: true
                }).on('changeDate', function (e) {
                    $(this).datepicker('hide');
                    added.date = that.utils.dateToLong(e.target.value);
                }).on('clearDate', function (e) {
                    added.date = 0;
                });

                if (that.mode == 'edit') {
                    $('#' + typeElId).val(added.type);
                    $('#' + dateElId).datepicker('update', that.utils.longToDateTimeFormatted(added.date, 'MM/DD/YYYY'));
                }
            });
        },

        onRemoveSurgery: function (event) {
            var row = $(event.target);
            var surveryId = row.parent().parent().attr('id');
            this.ffForm.medProfile.surgeries = this.ffForm.medProfile.surgeries.filter(function (s) {
                return s.id != surveryId;
            });
            this.ui.surgeriesTable.find('tr[id="' + surveryId + '"]').remove();
        },

        onChangeDiet: function (event) {
            this.ffForm.medProfile.diet = event.target.value;
        },

        onChangeAllergies: function (event) {
            this.ffForm.medProfile.allergy = event.target.value;
        },

        onChangeBriefMedicalHistory: function (event) {
            this.ffForm.medProfile.briefMedicalHistory = event.target.value;
        },

        onChangeComplications: function (event) {
            this.ffForm.medProfile.complication = event.target.value;
        },

        onChangeFfDataInput: function (event) {
            this.ffForm.data[event.target.name] = event.target.value;
        },

        onReferralTypeCheck: function (event) {
            var name = event.target.name;
            var checked = event.target.checked;
            if (checked) {
                this.ffForm.data.referralTypes.push(name);
            } else {
                this.ffForm.data.referralTypes = this.ffForm.data.referralTypes.filter(function (rt) {
                    return rt !== name;
                });
            }
        },

        onReasonCheck: function (event) {
            var name = event.target.name;
            var checked = event.target.checked;
            if (checked) {
                this.ffForm.data.reasons.push(name);
            } else {
                this.ffForm.data.reasons = this.ffForm.data.reasons.filter(function (rt) {
                    return rt !== name;
                });
            }
        },

        enableCreateButton: function () {
            this.ui.create.removeAttr('disabled');
        },

        disableCreateButton: function () {
            this.ui.create.attr('disabled', true);
        },

        showError: function (jQelement, text) {
            jQelement.tooltip({title: text});
            jQelement.parent().parent().addClass('has-error has-feedback');
        },

        clearError: function (jQelement) {
            jQelement.tooltip("destroy");
            jQelement.parent().parent().removeClass('has-error has-feedback');
        }
    })
;

module.exports = FaceToFaceFormView;


//////////////////
// WEBPACK FOOTER
// ./app/views/med-forms/face-to-face-form.js
// module id = 521
// module chunks = 0